var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"aliyun-captcha-guard"},[_c('span',{attrs:{"id":_vm.elementId}}),_c('button',{staticClass:"aliyun-captcha-guard__trigger",attrs:{"id":_vm.buttonId,"type":"button","tabindex":"-1","aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }